/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Handover_LinkInputs */

const en_faq_handover_link = /** @type {(inputs: Faq_Handover_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read about the handover.`)
};

const lv_faq_handover_link = /** @type {(inputs: Faq_Handover_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lasīt par sistēmas nodošanu`)
};

/**
* | output |
* | --- |
* | "Read about the handover." |
*
* @param {Faq_Handover_LinkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_handover_link = /** @type {((inputs?: Faq_Handover_LinkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Handover_LinkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_handover_link(inputs)
	return en_faq_handover_link(inputs)
});